<script setup lang="ts">
import { useRoute } from "vue-router";
import FrameLayout from "./layouts/FrameLayout.vue";
import DefaultLayout from "./layouts/DefaultLayout.vue";
import { useHead } from "@unhead/vue";
import lookAndFeel from "./config/lookAndFeel.ts";
import { BApp } from "bootstrap-vue-next";

const route = useRoute();
useHead({
  titleTemplate: (title) => (title ? `${title} - ${lookAndFeel.title}` : lookAndFeel.title),
});
</script>

<template>
  <BApp>
    <FrameLayout v-if="route.meta.layout === 'FrameLayout'" />
    <DefaultLayout v-else />
  </BApp>
</template>
